import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { fromStoreByIdQueryToStore } from "../../../../../../../adapters/v3/pages/BookAppointment/adapters/from-store-by-id-query-to-store.js";
import { GET_BOOK_APPOINTMENT_STORE_BY_ID } from "../../../../../../../queries/v3/pages/BookAppointment/queries/get-book-appointment-store-by-id.js";
const useBookAppointmentStoreById = ({
  isTryInStoreFlowEnabled = false,
  isGroupIdEnabled = null
} = {}) => {
  const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_STORE_BY_ID);
  const { locale } = useIntl();
  if (queryState.error) {
    console.error(queryState.error);
  }
  const getBookAppointmentStoreById = React.useCallback(
    (globalStoreId) => query({
      variables: { globalStoreId },
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    }),
    [query, locale]
  );
  const data = React.useMemo(
    () => fromStoreByIdQueryToStore(queryState.data?.store, [
      { tryInStore: isTryInStoreFlowEnabled, groupId: isGroupIdEnabled }
    ]),
    [queryState.data, isGroupIdEnabled]
  );
  return React.useMemo(
    () => [getBookAppointmentStoreById, { ...queryState, data }],
    [getBookAppointmentStoreById, queryState, data]
  );
};
export {
  useBookAppointmentStoreById as default
};
//# sourceMappingURL=use-book-appointment-store-by-id.js.map
